import { OwnerTypes } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const INITIAL_PAGINATION_VALUES = { pageIndex: 0, pageSize: 10 };

export const CITY_LEDGER_INVOICE_ACTION_DROPDOWN_DATA_TEST_ID = 'city-ledger-invoice-action-dropdown';
export const CITY_LEDGER_ACCOUNT_ACTION_DROPDOWN_DATA_TEST_ID = 'city-ledger-account-action-dropdown';

export const ownerTypes = {
    [OwnerTypes.Customer]: TextKey.Customer,
    [OwnerTypes.Company]: TextKey.Company,
    [OwnerTypes.OnlineTravelAgency]: TextKey.TravelAgency,
};

export enum ExportType {
    EXPORT = 'export',
    PRINT = 'print',
    RECURRING = 'recurring',
}
